import { CommonStyles } from '~common/react/CommonStyles';
import { SettingsStyles } from '~src/settings/styles/CommonStyles';
import { cssClass } from '~src/style';

const SALESFORCE_SETTINGS_PREFIX = 'salesforce-settings';
const SLACK_SETTINGS_PREFIX = 'slack-settings';
const INTEGRATION_SETTINGS_PREFIX = 'integration-settings';
const SETTINGS_CONTAINER_INDENT = '85px';
const SLACK_SETTING_COMMON_SPACE = '16px';

export const integrationSpaceContainer = cssClass(INTEGRATION_SETTINGS_PREFIX, 'space', {
  display: 'block',
  paddingTop: CommonStyles.Sizes.XLargeSpace
});

export const integrationSpaceAuthenticateContainer = cssClass(INTEGRATION_SETTINGS_PREFIX, 'space', {
  display: 'block',
  paddingTop: CommonStyles.Sizes.LineHeight
});

export const integrationSettingsContainer = cssClass(INTEGRATION_SETTINGS_PREFIX, 'container', {
  marginLeft: SETTINGS_CONTAINER_INDENT,
  paddingBottom: CommonStyles.Sizes.DefaultSpace,
  maxWidth: '508px'
});

export const integrationSettingConnectButton = cssClass(INTEGRATION_SETTINGS_PREFIX, 'connect-button', {
  marginBottom: CommonStyles.Sizes.LineHeight,
});

export const integrationsSettingsPageHeader = cssClass(INTEGRATION_SETTINGS_PREFIX, 'page-header', {
  ...SettingsStyles.settingsGroupNameProperties,
  paddingBottom: CommonStyles.Sizes.LineHeight,
  margin: 0,
});

export const salesforceSettingsGroupName = cssClass(SALESFORCE_SETTINGS_PREFIX, 'group-name', {
  paddingBottom: CommonStyles.Sizes.LineHeight,
  fontSize: CommonStyles.Sizes.NormalFontSize,
  margin: 0,
});

export const salesforceSettingsAfterConnecting = cssClass(SALESFORCE_SETTINGS_PREFIX, 'group-name', {
  fontSize: CommonStyles.Sizes.NormalFontSize,
  margin: 0,
});

export const salesforceSettingsParagraph = cssClass(SALESFORCE_SETTINGS_PREFIX, 'paragraph', {
  margin: 0,
  paddingBottom: CommonStyles.Sizes.LineHeight,
});

export const salesforceSettingsGroupContainer = cssClass(SALESFORCE_SETTINGS_PREFIX, 'group-container', {
  paddingBottom: CommonStyles.Sizes.LineHeight,
  paddingLeft: CommonStyles.Sizes.LargeSpace,
});

export const slackConnectivityMainHeader = cssClass(SLACK_SETTINGS_PREFIX, 'main-header', {
  margin: '6px'
});

export const slackLogo = cssClass(SLACK_SETTINGS_PREFIX, 'logo', {
  height: '16px',
  width: '16px',
  paddingTop: '6px'
});

export const slackSettingsGroupContainer = cssClass(SLACK_SETTINGS_PREFIX, 'group-container', {
  paddingBottom: SLACK_SETTING_COMMON_SPACE
});

export const slackSettingsHeaderContainer = cssClass(SLACK_SETTINGS_PREFIX, 'header-container', {
  display: 'flex'
});

export const slackInfoText = cssClass(SLACK_SETTINGS_PREFIX, 'text', {
  marginTop: SLACK_SETTING_COMMON_SPACE
});

export const slackAddOauthClientButton = cssClass(SLACK_SETTINGS_PREFIX, 'oauth-button', {
  marginTop: SLACK_SETTING_COMMON_SPACE,
  marginBottom: SLACK_SETTING_COMMON_SPACE,
  display: 'block'
});